import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { PolygonIcon, CircleIcon, LineIcon, LocationPinIcon } from '../../../../Mapbox/Icons';

import { Typography, Box, makeStyles, Switch } from '@material-ui/core';

import { setShapeFeatureProperty } from '../../../../../redux/map/Actions';
import { MAIN_MAP } from '../../../../../redux/map/Constants';
import PanelHeader from '../../PanelHeader';

const propTypes = {};

const defaultProps = {};

const useStyles = makeStyles(theme => styles(theme));

function NewSketchesHeader({ onClick, isCompact }) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const drawModule = useSelector(state => state[MAIN_MAP].drawModule);
    const drawingFeature = useSelector(state => state[MAIN_MAP].drawingFeature);
    const { firstName } = useSelector(state => state.user);

    const featureIds = isDrawing
        ? [drawingFeature.properties.id]
        : drawModule.getDrawControl().getSelectedIds();
    const feature = drawingFeature || drawModule.getDrawControl().get(featureIds[0]);
    const isDrawing =
        drawingFeature &&
        !_.isEmpty(drawingFeature) &&
        drawingFeature.geometry.coordinates.length > 0 &&
        !drawModule.getDrawControl().getSelectedIds().includes(drawingFeature.id);

    const [name, setName] = useState('');
    const [shapeName, setShapeName] = useState('');
    const isLocked = Boolean(feature?.properties?.isLocked);

    function dispatchSetShapeFeatureProperty(userProperty, userPropertyValue) {
        dispatch(setShapeFeatureProperty(feature?.id, userProperty, userPropertyValue, MAIN_MAP));
    }

    function handleChange(e) {
        dispatchSetShapeFeatureProperty('isLocked', e.target.checked);
    }

    useEffect(() => {
        function createIcon(feature) {
            if (feature?.properties?.radius) {
                setName('Circle');
            } else if (feature?.geometry?.type === 'Polygon') {
                setName('Polygon');
            } else if (feature?.geometry?.type === 'LineString') {
                setName('Line');
            } else if (feature?.geometry?.type === 'Point') {
                setName('Pinpoint');
            } else {
                setName('');
            }
        }
        setShapeName(feature?.properties?.name);

        createIcon(feature);
    }, [feature, isLocked]);

    // Render the appropriate icon component based on name
    let iconComponent;
    if (name === 'Circle') {
        iconComponent = <CircleIcon />;
    } else if (name === 'Polygon') {
        iconComponent = <PolygonIcon />;
    } else if (name === 'Line') {
        iconComponent = <LineIcon />;
    } else if (name == 'Pinpoint') {
        iconComponent = <LocationPinIcon />;
    } else {
        iconComponent = null;
    }

    return (
        !isDrawing &&
        drawingFeature !== null && (
            <PanelHeader isCompact={isCompact} onClick={onClick} isExpandable={true}>
                {iconComponent}
                <Typography variant="h4" color="secondary">
                    {shapeName ? shapeName : `${firstName}'s ${name}`}
                </Typography>

                <Box classes={{ root: classes.switchLabel }}>
                    <Typography variant="body1" color="textPrimary">
                        {isLocked ? 'Lock Shape' : 'Editable'}
                    </Typography>
                </Box>
                <Box classes={{ root: classes.switchButton }}>
                    <Switch checked={isLocked} onChange={e => handleChange(e)} />
                </Box>
            </PanelHeader>
        )
    );
}

const styles = theme => ({
    switchButton: {
        flexGrow: 0.1
    },
    switchLabel: {
        display: 'flex',
        flexGrow: 2,
        justifyContent: 'flex-end'
    }
});

NewSketchesHeader.propTypes = propTypes;
NewSketchesHeader.defaultProps = defaultProps;

export default NewSketchesHeader;
